module.exports = __webpack_public_path__ + "img/5-4.2295a54b.svg";